import { usePagesRedirect } from '@shared/hooks/use-pages-redirect.ts';

export const useClientAboutEditPageRedirect = () => {
  return usePagesRedirect('clientAboutEditPage');
};
